import { render, staticRenderFns } from "./SnackMsg.vue?vue&type=template&id=82b38dfc&scoped=true&"
import script from "./SnackMsg.vue?vue&type=script&lang=js&"
export * from "./SnackMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b38dfc",
  null
  
)

export default component.exports